<template>
  <div style="padding: 20px 0">
    <div class="tops">
      <div class="back-btn" @click="backPhy">
        <img src="../assets/image/back2.png" />返回
      </div>
      <div class="title">{{ orgName }}系统</div>
      <div></div>
    </div>
    <div class="summary_table">
      <div class="tr">
        <div class="th">名称</div>
        <div class="th">功能值</div>
        <div class="th">修复值</div>
        <div class="th" @click="showDialog">
          <img src="../assets/image/setUp.png" />
        </div>
      </div>
      <div v-for="(item, index) in tableData" :key="index">
        <div class="tr">
          <div class="td">
            <img
              class="warn-img"
              v-show="item.level > 2"
              :src="item.level > 3 ? img1 : item.level > 2 ? img2 : ''"
            />{{ item.name }}
          </div>
          <div class="td">
            <span
              :class="
                item.functional_status < -20
                  ? 'blue'
                  : item.functional_status > 20
                  ? 'orange'
                  : 'green'
              "
              >{{ item.functional_status }}</span
            >
          </div>
          <div class="td">
            <span
              :class="
                item.transition < -20
                  ? 'blue'
                  : item.transition > 20
                  ? 'orange'
                  : 'green'
              "
              >{{ item.transition }}</span
            >
          </div>
          <div class="td">
            <span @click="handleDetail(item)">
              <img
                src="../assets/image/downUp.png"
                :class="item.showDetail ? '' : 'trans180'"
              />
            </span>
          </div>
        </div>
        <div v-show="item.showDetail" class="details">
          <TableDetail :details="item" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TableDetail from "@/components/TableDetail";
export default {
  name: "OrganDetail",
  components: { TableDetail },
  props: {
    list: {
      type: Object,
      default() {
        return {};
      },
    },
    organName: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      tableData: [],
      orgName: "",
      img1: require("../assets/image/alert.png"),
      img2: require("../assets/image/warning.png"),
    };
  },
  watch: {
    organName(newVal) {
      this.orgName = newVal;
      this.tableData = this.list[this.handleData(newVal)];
    },
  },
  created() {
    this.tableData = this.list[this.handleData(this.organName)];
  },
  methods: {
    showDialog() {
      this.$emit("show-dialog");
    },
    /** 返回生理系统风险 */
    backPhy() {
      this.$emit("hide-details");
    },
    /** 显示详情 */
    handleDetail(item) {
      // debugger
      item.showDetail = !item.showDetail;
    },
    /** 获取对应数据 */
    handleData(name) {
      let keyName = "";
      switch (name) {
        case "内分泌":
          keyName = "endocrinium";
          break;
        case "循环":
          keyName = "circulation";
          break;
        case "消化":
          keyName = "digestion";
          break;
        case "免疫淋巴":
          keyName = "immune_lymphatic";
          break;
        case "运动":
          keyName = "motor";
          break;
        case "呼吸":
          keyName = "respiratory";
          break;
        case "泌尿生殖":
          keyName = "urinary";
          break;
        case "神经":
          keyName = "nervous";
          break;
      }
      return keyName;
    },
  },
};
</script>
<style lang="scss" scoped>
.tops {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  margin-top: -20px;
  margin-bottom: 20px;
  .title {
    font-size: 32px;
    flex: 3;
    font-weight: bold;
  }
  div {
    &:last-child {
      flex: 1;
    }
  }
}
.back-btn {
  font-size: 30px;
  width: 120px;
  height: 60px;
  padding: 5px 15px;
  display: flex;
  align-items: center;
  background-color: #2e94e5;
  border-radius: 8px;
  color: #fff;
  img {
    width: 45px;
    margin-right: 15px;
  }
}
.summary_table {
  width: 700px;
  margin: auto;
  border-radius: 5px;
  overflow: hidden;
  font-size: 32px;
}
.summary_table .tr {
  display: flex;
  justify-content: space-between;
}
.summary_table .tr .th {
  background-color: #2e94e5;
  text-align: center;
  color: #fff;
  height: 68px;
  line-height: 68px;
  border: 1px solid #ddd;
  border-bottom: none;
  box-sizing: border-box;
  flex: 1;
  &:first-child {
    flex: 2;
  }
}
.summary_table .tr .th:nth-child(2) {
  border-left: none;
  border-right: none;
}
.summary_table .tr .th img {
  width: 35px;
  height: 35px;
  vertical-align: middle;
}
.summary_table .tr .td {
  text-align: center;
  flex: 1;
  background-color: #fff;
  border: 1px solid #ddd;
  border-top: none;
  height: 68px;
  line-height: 68px;
  &:first-child {
    flex: 2;
  }
}
.summary_table .tr .td span {
  // margin-left: 10px;
}
.summary_table .tr .td em {
  display: inline-block;
  min-width: 80px;
  font-style: normal;
}

.summary_table .tr .lasttd em {
  width: 100%;
}
.summary_table .tr .td:nth-child(2) {
  border-left: none;
  border-right: none;
}
.summary_table .tr .td img {
  width: 32px;
}
.trans180 {
  transform: rotate(180deg);
}
.blue {
  color: #41b2ff;
}
.orange {
  color: #f99c3f;
}
.green {
  color: #20c384;
}
.summary_table .tr .td img.warn-img {
  width: 25px;
  margin-right: 10px;
}
</style>